import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/projects/ProjectGeneralForm.scss';
import { __ } from '../../core/utils';
import Select from '../../components/Select';
import * as _ from 'lodash';
import autobind from 'autobind-decorator';
import { enableAutosave } from '../../redux/actions/general/autosave';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import Checkbox from '../../components/Checkbox';
import classNames from 'classnames';
import DateTimePicker from '../../components/DateTimePicker';
import Input from '../../components/Input';

@reduxForm({
  form: 'projects.financial',
  enableReinitialize: true,
})
class ProjectFinancialForm extends Component {
  UNSAFE_componentWillReceiveProps() {
    enableAutosave('projects.financial');
  }

  @autobind
  _handleChangeCurrency(e, currency_id) {
    e.preventDefault();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description:
        'Do you really want to change the project language?\n\nThis will affect all the displayed currencies (and calculations) in the project current sets!',
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes'),
          onClick: () => {
            hideAlertbox();

            this.props.touch('currency_id');
            this.props.change('currency_id', currency_id);
            this.props.blur('currency_id');
          },
        },
      ],
    });
  }

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <div className={styles.wrapper}>
          <div className={styles.title}>{__('Financial')}</div>
          <div className={styles.form}>
            <div className={styles.flex}>
              <div className={styles.f1}>
                <Field
                  name='currency_id'
                  onChange={this._handleChangeCurrency}
                  disabled={!this.props.isProjectAdministrator}
                  component={Select}
                  searchable
                  label={__('project-settings.general-form.currency')}
                  options={_.map(
                    this.props.localization.currencies,
                    (currency) => ({
                      label: [currency.code, currency.name].join(' - '),
                      value: currency.id,
                    })
                  )}
                />
              </div>
              {/* <div
                className={classNames(styles.f1, styles.billable, styles.flex)}
              >
                <Field
                  name='is_billable'
                  component={Checkbox}
                  label={__('project-settings.general-form.billable')}
                  className={styles.checkbox}
                  disabled={!this.props.isProjectAdministrator}
                />
              </div> */}
            </div>
            <div className={styles.flex}>
              <div className={classNames(styles.f4, styles.dateWrapper)}>
                <Field
                  name='date'
                  disabled={!this.props.isProjectAdministrator}
                  component={DateTimePicker}
                  label={__('project-settings.general-form.date-range')}
                  footer
                  range
                  dropdown
                  clearDate
                  presets
                />
              </div>
              <div className={classNames(styles.f4, styles.duration)}>
                <Field
                  name='date.duration'
                  disabled={!this.props.isProjectAdministrator}
                  component={Input}
                  label={__('project-settings.general-form.duration')}
                  placeholder={__(
                    'project-settings.general-form.enter-duration'
                  )}
                />
              </div>
              {/* <div className={classNames(styles.f1, styles.deadline)}>
                <div className={styles.deadlineLabel}>
                  {__('project-settings.general-form.deadline')}
                </div>
                <Field
                  name='date.deadline'
                  component={Checkbox}
                  className={styles.checkbox}
                  onChange={() => {}}
                />
              </div> */}
            </div>
            <div className={styles.flex}>
              <div className={classNames(styles.f1, styles.deadline)}>
                <div className={styles.deadlineLabel}>
                  {__('project-settings.general-form.deadline')}
                </div>
                <Field
                  name='date.deadline'
                  component={Checkbox}
                  className={styles.checkbox}
                  disabled={!this.props.isProjectAdministrator}
                  onChange={() => {}}
                />
              </div>
              <div className={classNames(styles.f1, styles.deadline)}>
                <div className={styles.deadlineLabel}>
                  {__('project-settings.general-form.billable')}
                </div>
                <Field
                  name='is_billable'
                  component={Checkbox}
                  className={styles.checkbox}
                  disabled={!this.props.isProjectAdministrator}
                  onChange={() => {}}
                />
              </div>
              {/* <div
                className={classNames(styles.f1, styles.billable, styles.flex)}
              >
                <Field
                  name='is_billable'
                  component={Checkbox}
                  label={__('project-settings.general-form.billable')}
                  className={styles.checkbox}
                  disabled={!this.props.isProjectAdministrator}
                />
              </div> */}
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default ProjectFinancialForm;
